export default __webpack_public_path__ + "static/media/DSC_0526.ae9dc8be.webp";